import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { apiSignOut } from 'src/api/account/organizer';
import { apiAccountOUTERSignup, apiAccountSignin } from 'src/api/account/profile';
import { dispatchShowTemplateGalleryModal } from 'src/store/commonPart';
import { commonSlice } from 'src/store/commonPart/slice';
import { percentageLoadingMiddleware } from 'src/store/percentageLoadingMiddleware';
import { rootReducers } from 'src/store/rootReducers';
import { currentUserSlice } from 'src/store/user/slice';
import { eventPublishAuthChanged } from 'src/utils/outer';
import { showPlusSubscriptionModal, showPlanSelectionModal } from 'src/store/plusSubscription/helpers';
import { dispatchOverlaySliceShow } from 'src/store/overlay/helpers';

export const sagaMiddleware = createSagaMiddleware({
  onError(err) {
    // eslint-disable-next-line no-console
    console.error(err);
  },
});

export const store = configureStore({
  reducer: rootReducers,
  middleware: [...getDefaultMiddleware({ thunk: false }), ...[sagaMiddleware, percentageLoadingMiddleware]],
  devTools:
    process.env.NODE_ENV === 'development'
      ? {
          name: 'rallyup-devtools',
          trace: true,
        }
      : false,
});

const onSoftLogout = () => {
  eventPublishAuthChanged(null);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  store.dispatch(currentUserSlice.actions.getCurrentUserOk(null));
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  store.dispatch(commonSlice.actions.setSidebarModel(null));
};

window.spa = {
  signin: (data, cb) => {
    if (data) {
      const callback = cb || Function.prototype;

      apiAccountSignin(data)
        .then((response) => {
          store.dispatch(currentUserSlice.actions.getCurrentUserStart());
          callback(response);
        })
        .catch(callback);
    } else {
      // eslint-disable-next-line no-console
      console.error('data should exist');
    }
  },
  signout: (cb) => {
    const callback = cb || Function.prototype;

    apiSignOut('/signin')
      .then(({ RedirectUrl }) => {
        callback(RedirectUrl);

        onSoftLogout();
      })
      .catch(callback);
  },
  signup: (data, cb) => {
    if (data) {
      const callback = cb || Function.prototype;

      apiAccountOUTERSignup(data)
        .then((response) => {
          store.dispatch(currentUserSlice.actions.getCurrentUserStart());
          callback(response);
        })
        .catch(callback);
    } else {
      // eslint-disable-next-line no-console
      console.error('data should exist');
    }
  },
  onSignout: onSoftLogout,
  showLoginModal: () => null, // declare later (AnywhereLoginModal)
  showTemplateGalleryModal: (calledFrom) => dispatchShowTemplateGalleryModal(calledFrom),

  showExclusiveModal: showPlusSubscriptionModal,
  showPlanSelectionModal,
  showUpgradeNowModal: () => showPlusSubscriptionModal('upgradeNow', { canClose: true }),
  showDonorProfileOverlay: (id: number) => {
    dispatchOverlaySliceShow({ id, type: 'donorProfile' });
  },
};

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
